// Auto-generated by scripts/build_hfp_v3.py — do not edit manually
import hfpV3ExecutiveFunction from './hfpV3ExecutiveFunction.json';
import hfpV3Sensory from './hfpV3Sensory.json';
import hfpV3SocialEmotional from './hfpV3SocialEmotional.json';
import hfpV3MotorPhysical from './hfpV3MotorPhysical.json';
import hfpV3SpeechLanguageCommunication from './hfpV3SpeechLanguageCommunication.json';
import hfpV3GlobalParticipation from './hfpV3GlobalParticipation.json';
import hfpV3EnvironmentalFactors from './hfpV3EnvironmentalFactors.json';

export const HFP_V3_SCHEMAS = {
  hfpV3ExecutiveFunction,
  hfpV3Sensory,
  hfpV3SocialEmotional,
  hfpV3MotorPhysical,
  hfpV3SpeechLanguageCommunication,
  hfpV3GlobalParticipation,
  hfpV3EnvironmentalFactors,
};

export const HFP_V3_FORM_KEYS = [
  'hfpV3ExecutiveFunction',
  'hfpV3Sensory',
  'hfpV3SocialEmotional',
  'hfpV3MotorPhysical',
  'hfpV3SpeechLanguageCommunication',
  'hfpV3GlobalParticipation',
  'hfpV3EnvironmentalFactors',];

export const HFP_V3_SCHEMAS_LIST = [
  hfpV3ExecutiveFunction,
  hfpV3Sensory,
  hfpV3SocialEmotional,
  hfpV3MotorPhysical,
  hfpV3SpeechLanguageCommunication,
  hfpV3GlobalParticipation,
  hfpV3EnvironmentalFactors,];

export default HFP_V3_SCHEMAS;
